<div>
	<div class="row">
		<div class="col-lg-2 col-md-3 col-sm-3" *ngIf="showScheme">
			<label>Scheme/Program/Model</label>
			<div>
				<angular2-multiselect [data]="dropdownListScheme" (click)="getFilteredData()" [(ngModel)]="selectedItemsScheme"
				 [settings]="dropdownSettingsScheme" (onClose)="onCloseSchemeDropdown()">
					<c-item>
						<ng-template let-item="item">
							<label style="color: #333;min-width: 150px;">{{item.itemName}}</label>
						</ng-template>
					</c-item>
				</angular2-multiselect>
			</div>
		</div>
		<div class="col-lg-2 col-md-3 col-sm-3" *ngIf="showBatchTypes">
			<div>
				<label>Batch Type:</label>
				<div>
					<angular2-multiselect [data]="dropdownListBatchType" (click)="getFilteredData()" [(ngModel)]="selectedItemsBatchTypes"
					 [settings]="dropdownSettingsBatchType" (onClose)="onCloseBatchTypeDropdown()" (onOpen)="getBatchTypes()">
						<c-item>
							<ng-template let-item="item">
								<label style="color: #333;min-width: 150px;">{{item.itemName}}</label>
							</ng-template>
						</c-item>
					</angular2-multiselect>
				</div>
			</div>
		</div>
		<div class="col-lg-2 col-md-3 col-sm-1" *ngIf="showJobRoles">
			<div>
				<label>Job Role</label>
				<br>
				<angular2-multiselect [data]="dropdownListQpCode" [(ngModel)]="selectedItemsQpCodes" [settings]="dropdownSettingsQpCodes"
				 (onClose)="onCloseQpCodeDropdown()">
					<c-item>
						<ng-template let-item="item">
							<label style="color: #333;min-width: 150px;">{{item.itemName}}</label>
						</ng-template>
					</c-item>
				</angular2-multiselect>
			</div>
		</div>
		<div class="col-lg-2 col-md-3 col-sm-3" *ngIf="showRequest">
			<label>Request Type</label>
			<div>
				<angular2-multiselect [data]="dropdownListRequest" (click)="getFilteredData()" [(ngModel)]="selectedItemsRequest"
				 [settings]="dropdownSettingsRequest" (onClose)="onCloseRequestDropdown()">
					<c-item>
						<ng-template let-item="item">
							<label style="color: #333;min-width: 150px;">{{item.itemName}}</label>
						</ng-template>
					</c-item>
				</angular2-multiselect>
			</div>
		</div>
		<div class="col-lg-2 col-md-3 col-sm-3" *ngIf="showTotName">
			<label>ToT/ToA Name</label>
			<div>
				<angular2-multiselect [data]="dropdownListTotName" (click)="getFilteredData()" [(ngModel)]="selectedItemsTotName"
				 [settings]="dropdownSettingsTotName" (onClose)="onCloseTotNameDropdown()">
					<c-item>
						<ng-template let-item="item">
							<label style="color: #333;min-width: 150px;">{{item.itemName}}</label>
						</ng-template>
					</c-item>
				</angular2-multiselect>
			</div>
		</div>
		<div class="col-lg-2 col-md-3 col-sm-3" *ngIf="showStates">
			<label>State :</label>
			<div>
				<angular2-multiselect [data]="dropdownListStates" (click)="getFilteredData()" [(ngModel)]="selectedItemsStates"
				 [settings]="dropdownSettingsStates" (onClose)="onCloseStatesDropdown()">
					<c-item>
						<ng-template let-item="item">
							<label style="color: #333;min-width: 150px;">{{item.itemName}}</label>
						</ng-template>
					</c-item>
				</angular2-multiselect>
			</div>
		</div>
		<div class="col-lg-2 col-md-3 col-sm-3" *ngIf="showDistricts">
			<label>District :</label>
			<div>
				<angular2-multiselect [data]="dropdownListDistricts" (click)="getFilteredData()" [(ngModel)]="selectedItemsDistricts"
				 [settings]="dropdownSettingsDistricts" (onClose)="onCloseDistrictsDropdown()">
					<c-item>
						<ng-template let-item="item">
							<label style="color: #333;min-width: 150px;">{{item.itemName}}</label>
						</ng-template>
					</c-item>
				</angular2-multiselect>
			</div>
		</div>
		<div class="col-6" *ngIf="showDates">
			<div>
				<label>Batch Start and End Dates:</label>
				<div class="row">
					<div class="col-5">
						<div class="input-group ">
							<input style="cursor: pointer;" type="text" class="form-control m-input" #startDate (blur)="assignBatchStartDate();getFilteredData()"
							 id="fullDate" placeholder="Start Date" />
							<div class="input-group-append ">
								<span class="input-group-text ">
									<i class="la la-calendar"></i>
								</span>
							</div>
						</div>
					</div>
					<div class="col-5">
						<div class="input-group ">
							<input style="cursor: pointer;" type="text" class="form-control m-input" #endDate (blur)="assignBatchEndDate();getFilteredData()"
							 id="fullDate" placeholder="End Date" />
							<div class="input-group-append">
								<span class="input-group-text ">
									<i class="la la-calendar"></i>
								</span>
							</div>
						</div>
					</div>
					<div>
						<button (click)="resetDates()" class="btn btn-primary reset-style" type="reset">
							<i class="fa flaticon-refresh"></i>
						</button>
					</div>
				</div>
			</div>
		</div>
		<div class="col-lg-2 col-md-3 col-sm-3" *ngIf="showStatus">
			<label>Status :</label>
			<div>
				<angular2-multiselect [data]="dropdownListStatus" (click)="getFilteredData()" [(ngModel)]="selectedItemsStatus"
				 [settings]="dropdownSettingsStatus" (onClose)="onCloseStatusDropdown()">
					<c-item>
						<ng-template let-item="item">
							<label style="color: #333;min-width: 150px;">{{item.itemName}}</label>
						</ng-template>
					</c-item>
				</angular2-multiselect>
			</div>
		</div>
		<div class="col-lg-2 col-md-2 col-sm-2" *ngIf="showSearch">
			<div>
				<label>Keyword Search:</label>
				<div>
					<div class="input-group">
						<app-search (searchValue)="setSearchText($event)" (change)="getFilteredData()" [placeholder]="showSearchText"
						 class="width-100 "></app-search>
					</div>
				</div>
			</div>
		</div>
		<div class="col-lg-2 col-md-2 col-sm-2" *ngIf="showSearchButton">
			<label> </label>
			<div class="alignment-btn">
				<button class="btn btn-info color-info" (click)="getFilteredData()">Search</button>
			</div>
		</div>
	</div>
	<!-- <div class="col-sm-6" *ngIf="showBatchTypes">
		<label>Batch Type:</label>
		<div class="col-sm-6">
			<angular2-multiselect [data]="dropdownListBatchType" [(ngModel)]="selectedItemsBatchTypes" [settings]="dropdownSettingsBatchType"
			 (onClose)="onCloseBatchTypeDropdown()" (onOpen)="getBatchTypes()">
				<c-item>
					<ng-template let-item="item">
						<label style="color: #333;min-width: 150px;">{{item.itemName}}</label>
					</ng-template>
				</c-item>
			</angular2-multiselect>
		</div>
	</div> -->
	<!-- <div class="col-md-3" *ngIf="showJobRoles">
		<label>Job Role (QP Code): </label>
		<br>
		<angular2-multiselect [data]="dropdownListQpCode" [(ngModel)]="selectedItemsQpCodes" [settings]="dropdownSettingsQpCodes"
		 (onClose)="onCloseQpCodeDropdown()">
			<c-item>
				<ng-template let-item="item">
					<label style="color: #333;min-width: 150px;">{{item.itemName}}</label>
				</ng-template>
			</c-item>
		</angular2-multiselect>
	</div> -->
	<!-- <div class="row">
		<div class="col-sm-6" *ngIf="showStates">
			<label>State :</label>
			<div class="col-sm-6">
				<angular2-multiselect [data]="dropdownListStates" [(ngModel)]="selectedItemsStates" [settings]="dropdownSettingsStates" (onClose)="onCloseStatesDropdown()">
					<c-item>
						<ng-template let-item="item">
							<label style="color: #333;min-width: 150px;">{{item.itemName}}</label>
						</ng-template>
					</c-item>
				</angular2-multiselect>
			</div>
		</div>
		<div class="col-sm-6" *ngIf="showDistricts">
			<label>District :</label>
			<div class="col-sm-6">
				<angular2-multiselect [data]="dropdownListDistricts" [(ngModel)]="selectedItemsDistricts" [settings]="dropdownSettingsDistricts"
				 (onClose)="onCloseDistrictsDropdown()">
					<c-item>
						<ng-template let-item="item">
							<label style="color: #333;min-width: 150px;">{{item.itemName}}</label>
						</ng-template>
					</c-item>
				</angular2-multiselect>
			</div>
		</div>
	</div> -->
	<!-- <div class="m-content col-sm-12" *ngIf="showDates">
		<div class="col-sm-12">
			<label>Batch Start and End Dates:</label>
			<div class="row">
				<div class="col-sm-4">
					<div class="input-group ">
						<input style="cursor: pointer;" type="text" class="form-control m-input" #startDate (blur)="assignBatchStartDate()" id="fullDate"
						 placeholder="Select batch start date" />
						<div class="input-group-append ">
							<span class="input-group-text ">
								<i class="la la-calendar-check-o "></i>
							</span>
						</div>
					</div>
				</div>
				<div class="col-sm-4">
					<div class="input-group ">
						<input style="cursor: pointer;" type="text" class="form-control m-input" #endDate (blur)="assignBatchEndDate()" id="fullDate"
						 placeholder="Select batch end date" />
						<div class="input-group-append">
							<span class="input-group-text ">
								<i class="la la-calendar-check-o "></i>
							</span>
						</div>
					</div>
				</div>
				<div class="col-sm-4">
					<input (click)="resetDates()" class="btn btn-danger" type="reset" value="Reset" style="margin-left: 45px;width: 88px;height: 35px;">
				</div>
			</div>
		</div>
	</div> -->
	<!-- <div class="m-content col-sm-12" *ngIf="showSearch">
		<div class="col-sm-12">
			<label>Search by Batch ID:</label>
			<div class="row">
				<div class="col-sm-8">
					<div class="input-group ">
						<app-search (searchValue)="setSearchText($event) " class="width-100 "></app-search>
					</div>
				</div>
			</div>
		</div>
	</div> -->
</div>
